import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useDesigner } from '../../hooks/useDesigner';
import { useUrlParams } from '../../hooks/useUrlParams';
import { findRouteFor } from '../../routers';

export const usePLPFirstBreadcrumbTitle = () => {
  const { params } = useUrlParams();
  const location = useLocation();
  const route = findRouteFor(location.pathname);

  const { designer } = useDesigner(
    route?.key === 'DesignerPage' ? (params.designerSlug as string) : undefined
  );

  const title = useMemo(() => {
    if (route?.key === 'ProductCategoryListingPage') {
      if (params.section) {
        return `All ${params.section}`;
      }
    }

    if (route?.key === 'DesignerPage') {
      return designer?.name;
    }

    if (route?.key === 'FavoritesPage') {
      return 'All Favorites';
    }
    if (
      route?.key &&
      ['GuidePage', 'ProductSearchListingPage', 'DesignersIndexPage'].includes(route?.key)
    ) {
      return 'All Results';
    }
  }, [route, params, designer]);

  return title;
};
